import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { assertNever } from 'src_common/common/assertNever';
import { MarketTermsPropsType } from 'src/domains/sportsbook/webview/components/raceCard/raceDetails/raceCardMeta/types';
import {
    RaceMetaDataEwTerms,
    RaceMetaDataEwTermsItem,
} from 'src/domains/sportsbook/webview/components/raceCard/raceDetails/raceCardMeta/MarketTerms.style';

const renderTerms = (market: MarketModel): JSX.Element | null => {
    if (market.eachWayOffered) {
        const termsPlaces = market.eachWayTermsPlaces;
        const reduction = market.eachWayTermsReduction;

        if (termsPlaces !== undefined && reduction !== undefined) {
            return (
                <RaceMetaDataEwTerms data-test='race-header-item-meta-ew-terms'>
                    <RaceMetaDataEwTermsItem>
                        <strong>
                            <I18n
                                langKey='events.racecard.each-way-terms.label'
                                defaultText='EW:'
                            />
                        </strong>
                    </RaceMetaDataEwTermsItem>

                    <RaceMetaDataEwTermsItem>
                        <I18n
                            langKey='events.racecard.each-way-terms.we-are-paying'
                            defaultText='We are paying'
                        />
                    </RaceMetaDataEwTermsItem>

                    <RaceMetaDataEwTermsItem>{reduction}</RaceMetaDataEwTermsItem>

                    <RaceMetaDataEwTermsItem>
                        <I18n
                            langKey='events.racecard.each-way-terms.for'
                            defaultText='for'
                        />
                    </RaceMetaDataEwTermsItem>

                    <RaceMetaDataEwTermsItem>
                        <I18n
                            langKey='events.racecard.each-way-terms.places'
                            defaultText='{places} places'
                            params={{ places: termsPlaces }}
                        />
                    </RaceMetaDataEwTermsItem>
                </RaceMetaDataEwTerms>
            );
        }
    }

    return null;
};

export const MarketTerms = observer('RenderTherms', ({ activeFilterId, race }: MarketTermsPropsType) => {
    const marketWithout = race.marketWithout.at(0);
    const marketExtraPlaces = race.marketExtraPlaces.at(0);
    const marketRaceWinner = race.marketRaceWinner.at(0);

    const isExtraPlaces = marketExtraPlaces?.eachWayOffered === true;
    const isBettingWithout = marketWithout?.eachWayOffered === true;
    const isEachWayRaceWinner = marketRaceWinner?.eachWayOffered === true;

    switch (activeFilterId) {
        case 'lengthen-the-odds':
        case 'match-bets':
        case 'sub-race':
        case 'trap-challenge':
        case 'win-only':
        case 'place-only':
            return null;

        case 'extra-places':
            if (isExtraPlaces) {
                return renderTerms(marketExtraPlaces);
            }
            return null;

        case 'betting-without':
            if (isBettingWithout) {
                return renderTerms(marketWithout);
            }
            return null;

        case 'forecast-tricast':
        case 'Win or Ew':
        case null:
            if (isEachWayRaceWinner) {
                return renderTerms(marketRaceWinner);
            }
            return null;
        default:
            return assertNever('Unhandled active filter id', activeFilterId);
    }
});
